import { apiUrl } from "../../common/helpers/common";

function GoogleAuthButton() {
  return (
    <div className="my-4">
      <a href={`${apiUrl}/auth/google`}>
        <button className="flex justify-center items-center bg-gray-800 rounded-md w-full  text-white py-2 hover:bg-gray-700">
          <img
            src="./images/icons/google-icon.png"
            alt="continue with google"
            className="w-5 mr-4"
          />
          Continue with Google
        </button>
      </a>
    </div>
  );
}

export default GoogleAuthButton;
